import RowSeat from './3rdRowSeat.svg'
import AndroidAuto from './AndroidAuto.svg'
import AppleCarPlay from './AppleCarPlay.svg'
import AutomaticParking from './AutomaticParking.svg'
import BackUpCamera from './BackUpCamera.svg'
import BlindSpotMonitor from './BlindSpotMonitor.svg'
import Bluetooth from './Bluetooth.svg'
import BrakeAssist from './BrakeAssist.svg'
import ChromeWheels from './ChromeWheels.svg'
import CooledSeats from './CooledSeats.svg'
import EntertainmentSystem from './EntertainmentSystem.svg'
import HandsFreeLiftgate from './HandsFreeLiftgate.svg'
import HeadsUpDisplay from './HeadsUpDisplay.svg'
import HeatedSeats from './HeatedSeats.svg'
import HeatedSteeringWheel from './HeatedSteeringWheel.svg'
import KeylessStart from './KeylessStart.svg'
import LaneDepartureWarning from './LaneDepartureWarning.svg'
import LaneKeepingAssist from './LaneKeepingAssist.svg'
import LeatherSeats from './LeatherSeats.svg'
import NavigationSystem from './NavigationSystem.svg'
import PremiumSound from './PremiumSound.svg'
import RemoteStart from './RemoteStart.svg'
import SatelliteRadio from './SatelliteRadio.svg'
import SmartphoneIntegration from './SmartphoneIntegration.svg'
import SunroofMoonroof from './SunroofMoonroof.svg'
import TowHitch from './TowHitch.svg'
import TurboSupercharged from './TurboSupercharged.svg'
import WiFiHotspot from './WiFiHotspot.svg'

const equipment = {
  '3rdRowSeat': RowSeat,
  AndroidAuto: AndroidAuto,
  AppleCarPlay: AppleCarPlay,
  AutomaticParking: AutomaticParking,
  BackUpCamera: BackUpCamera,
  BlindSpotMonitor: BlindSpotMonitor,
  Bluetooth: Bluetooth,
  BrakeAssist: BrakeAssist,
  ChromeWheels: ChromeWheels,
  CooledSeats: CooledSeats,
  EntertainmentSystem: EntertainmentSystem,
  HandsFreeLiftgate: HandsFreeLiftgate,
  HeadsUpDisplay: HeadsUpDisplay,
  HeatedSeats: HeatedSeats,
  HeatedSteeringWheel: HeatedSteeringWheel,
  KeylessStart: KeylessStart,
  LaneDepartureWarning: LaneDepartureWarning,
  LaneKeepingAssist: LaneKeepingAssist,
  LeatherSeats: LeatherSeats,
  NavigationSystem: NavigationSystem,
  PremiumSound: PremiumSound,
  RemoteStart: RemoteStart,
  SatelliteRadio: SatelliteRadio,
  SmartphoneIntegration: SmartphoneIntegration,
  SunroofMoonroof: SunroofMoonroof,
  TowHitch: TowHitch,
  TurboSupercharged: TurboSupercharged,
  WiFiHotspot: WiFiHotspot
}

Object.keys(equipment).forEach(key => {
  if (!equipment[key].default) return // ESM does not have a default export
  equipment[key] = equipment[key].default
})

export default equipment

/**
 * Get an icon by the Popular Equipment name. Converts the human-readable title
 * to it's PascalCase equivelant in order to determine the appropriate icon.
 * @param {String} name
 * @return {Object}
 */
export function getEquipmentIcon (name) {
  name = name.replace(/[^A-Za-z0-9]/g, '')
  return equipment[name] || {}
}
